import {mapGetters} from "vuex";
import {convertObjToAddress} from "@/lib/lib";

export default {
	computed: {
		...mapGetters([
			"getShipmentsById",
			"isShipmentsFullLoad",
			"getShipmentsFullLoadById",
		]),
		isShipmentFullLoad() {
			return this.isShipmentsFullLoad || this.getShipmentsFullLoadById[this.shipmentId]
		},
		shipment() {
			return this.getShipmentsById[this.shipmentId]
		},
		routes() {
			return this.shipment?.routes
		},
		stopOrders() {
			return this.routes.map(r => r.stop_order) || []
		},
		routeStart() {
			return this.routes?.find(r => r.stop_order == Math.min(...this.stopOrders))
		},
		routeEnd() {
			return this.routes?.find(r => r.stop_order == Math.max(...this.stopOrders))
		},
		unitId() {
			return this.shipment?.unit_id
		},
		report() {
			return this.shipment?.report
		},
		name() {
			return this.shipment?.name
		},
		shipmentService() {
			return this.shipment?.service
		},
		addressFrom() {
			let route = this.routes?.find(r => r.stop_order == 0)
			let address = route?.address || {}
			let fullAddress = (!this.routeMeta?.isGuest || !route?.address_name) ? ` (${address?.fullName || convertObjToAddress(address.address)})` : ''
			return (route?.address_name || '') + fullAddress
		},
		addressTo() {
			let route = this.routes?.find(r => r.stop_order == 1)
			let address = route?.address || {}
			let fullAddress = (!this.routeMeta?.isGuest || !route?.address_name) ? ` (${address?.fullName || convertObjToAddress(address.address)})` : ''
			return (route?.address_name || '') + fullAddress
		},
		shipmentStatus() {
			return {
				isStarted: this.shipment?.status === 'started',
				isCompleted: ['completed', 'cancelled'].includes(this.shipment?.status),
			}
		},
		isShipmentStarted() {
			return this.shipmentStatus?.isStarted
		},
		isShipmentCompleted() {
			return this.shipmentStatus?.isCompleted
		},
		shipmentsNotes() {
			return [{name: '', notes: this.shipment?.notes || []}]
		},
		notesCount() {
			return this.shipmentsNotes?.reduce((count, s) => {
				count = count + (s?.notes?.length || 0)
				return count
			}, 0)
		},
		documentsCount() {
			return (this.shipment?.documents?.length || 0) + (this.report ? 1 : 0)
		},
		shipmentStartTime() {
			return this.shipment?.shipping__time
		},
		shipmentEndTime() {
			return this.shipment?.delivery__time
		},
		shipmentActualStartTime() {
			return this.shipment?.started__time
		},
		shipmentActualEndTime() {
			return this.shipment?.completed__time
		},
	},
	watch: {
	},
	methods: {}
}